module.exports = __webpack_public_path__ + "static/media/Christina Johnson Headshot.a22584a0.png";